import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { reducers } from './root-state';
import { RateTypeService } from './rate-type/rate-type.service';
import { RateTypeEffects } from './rate-type/rate-type.effects';
import { ProgramService } from './program/program.service';
import { ProgramEffects } from './program/program.effects';
import { LocationService } from './location/location.service';
import { LocationEffects } from './location/location.effects';
import { InstitutionsService } from './institutions/institutions.service';
import { InstitutionsEffects } from './institutions/institutions.effects';
import { ErrorEffects } from './error/error.effect';
import { CompareEffects } from './compare/compare.effects';
import { SavedEffects } from './saved/saved.effects';
import { metaReducers } from './meta-reducers';
import { CompareService } from './compare/compare.service';

@NgModule({
  imports: [
    CommonModule,
    StoreDevtoolsModule,
    StoreDevtoolsModule.instrument({
      maxAge: 25
    }),
    StoreModule.forRoot(reducers, { metaReducers }),
    EffectsModule.forRoot([
      RateTypeEffects,
      ProgramEffects,
      LocationEffects,
      InstitutionsEffects,
      ErrorEffects,
      CompareEffects,
      SavedEffects
    ])
  ],
  providers: [RateTypeService, ProgramService, LocationService, InstitutionsService, CompareService]
})
export class RootStoreModule {}
